import React from 'react'
import { Card, Col, Flex, Form, Row } from 'antd'
import { ModuleTopHeading, ProjectTrackTable } from '../../components';

const ProjectTracking = () => {

    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical gap={20}>
                            <ModuleTopHeading level={4} name='Project Tracking'/>
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <ProjectTrackTable/>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export { ProjectTracking }
